import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

type EntityContactRowsProps = {
  children: ReactNode
  className?: string
}

/** Vertical stack for grouped contact rows (e.g. personal vs social). */
export function EntityContactRows({ children, className }: EntityContactRowsProps) {
  return <div className={cn('space-y-2', className)}>{children}</div>
}
